module.exports = __webpack_public_path__ + "img/8.c3079206.jpg";